import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequirementTypesService {

  constructor(private http: HttpClient) { }

    getRequirementTypes() {
        return this.http.get(`${environment.apiUrl}/trackvision/requirementtype`, {
            headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
        })
    }

    async getRequirementTypesListOptions(): Promise<Array<{ id: number; text: string }>> {
      const headers = new HttpHeaders().set('Token', localStorage.getItem('access_token') || '');

      try {
        const response: any = await firstValueFrom(
          this.http.get(`${environment.apiUrl}/trackvision/requirementtype/list`, { headers })
        );

        if (response?.result) {
          return response.result.map((item: any) => ({
            id: Number(item.id),
            text: item.name
          }));
        }

        return [];
      } catch (error) {
        console.error('Error fetching requirement types list:', error);
        return this.getRequirementTypesOptions();
      }
    }

    async getRequirementTypesOptions(): Promise<any> {
      const headers = new HttpHeaders().set('Token', localStorage.getItem('access_token') || '');
      
      try {
        const response:any = await firstValueFrom(this.http.get(`${environment.apiUrl}/trackvision/requirementtype`, { headers }));
        if(response && response.result){
          return this.flattenRequirementTypeOptions(response.result);
        }
        return [];
      } catch (error) {
        console.error('Error fetching requirement types:', error);
        return [];
      }
    }

    private flattenRequirementTypeOptions(items: any[]): Array<{ id: number; text: string }> {
      const options: Array<{ id: number; text: string }> = [];

      const visit = (nodes: any[]) => {
        nodes.forEach((item) => {
          options.push({
            id: Number(item.id),
            text: item.fullname || item.name
          });

          if (Array.isArray(item.sub) && item.sub.length) {
            visit(item.sub);
          }
        });
      };

      visit(items);
      return options;
    }

    getRequirementTypesList() {
      return this.http.get(`${environment.apiUrl}/trackvision/requirementtype/list`, {
          headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      })
  }

  getDataRequirementSelected() {
    return this.http.post(`${environment.apiUrl}/trackvision/requirementtype/getdataelements`, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
}


}
